import React, {useEffect, useRef, useState, useCallback} from 'react';
import axios from 'axios'
import {showToast} from '../../../../Component/Toast';
import {encryptPassword} from '../../../../Utils/Crypto'
import {useHistory} from 'react-router-dom'
import Spinner from '../../../../Component/Loader'
import Button from '../../../../Component/Button'
import useClientHook from "../../../../Hooks/useClientHook";
import MultipleOrigins from '../../../../Component/MultipleOrigins/MultipleOrigins'
import Captcha from "../../../../Component/Captcha";
import useEmployeeHook from "../../useEmployeeHook";
const parseErrorMessage = (raw, fallback = 'Something went wrong. Please try again.') => {
	if (!raw) return fallback;
	let str = typeof raw === 'string' ? raw : JSON.stringify(raw);
	str = str.replace(/\\/g, '');
	const matches = [...str.matchAll(/"message":"([^"{}]+)"/g)];
	if (matches.length) {
		return matches[matches.length - 1][1];
	}
	return typeof raw === 'string' && raw.trim() ? raw : fallback;
}

function Index() {
	const URLS = useEmployeeHook()
	const HISTORY = useHistory();
	const [AuthMode, setAuthMode] = useState(undefined);
	const [Loader, setLoader] = useState(undefined);
	const [Recaptcha, setRecaptcha] = useState(false);
	const [showTncModal, setShowTncModal]=useState(false);
	//const [onboarded,setOnboarded] = useState(undefined);

	let params = new URLSearchParams(window.location.search)
	const [EmailValue, setEmailValue] = useState(params.get('prefill'));
	let tempLogin = params.get('temp_login')
	let {client_id, origin, logo, provider} = useClientHook('LOGIN');

	//Handling multiple origins for one user
	const [MultipleLogins, setMultipleLogins] = useState();
	const [SelectedOrigin, setSelectedOrigin] = useState(provider);
	const [Showorigins, setShoworigins] = useState();

	let Password = useRef(null)
	const [LoginMessage, setLoginMessage] = useState();

	const [BtnLoader, setBtnLoader] = useState(false);
	const captchaRef = useRef();

	const isYesBankOrigin=origin?.includes('yesleap') || origin?.includes('yespayleaf');

	const handleTnc = useCallback(event => {
		if (event.data.name === 'acceptTnc') {
			submitForm({
				termsAccepted: 'I accept',
				email: event.data.email,
				password: event.data.password,
				captcha: event.data.captcha,
				client_id: event.data.client_id,
				urls: event.data.urls
			}, true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		window.addEventListener('message', handleTnc);

		return () => window.removeEventListener('message', handleTnc);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [handleTnc]);

	useEffect(() => {
		//Handling redirect back in case of login attempt is false
		if (params.get('success') === 'false') {
			if (params.get('type')) {
				//If attempted login was using mobile
				if (params.get('type') === 'mobile') {
					HISTORY.push(`/mobile?success=${params.get('success')}&prefill=${params.get('prefill')}&message=${params.get('message')}origin=${origin}&provider=${SelectedOrigin}`)
				}
				//If attempted login was using email
				if (params.get('type') === 'email'){
					//If attempted login was using Code
					if (params.get('prefill').includes('|')) {
						HISTORY.push(`/code?type=code&success=${params.get('success')}&prefill=${params.get('prefill')}&message=${params.get('message')}&origin=${params.get('origin')}&provider=${SelectedOrigin}`)
					} else {
						if(EmailValue){
							setEmailValue(params.get('prefill'))
						}
						setAuthMode('PASSWORD')
					}
				}
			}
			setLoginMessage(new URLSearchParams(window.location.search).get('message'))
		}
		if (tempLogin) {
			setEmailValue(tempLogin)
			setAuthMode('PASSWORD')
		}
		// eslint-disable-next-line
	}, [HISTORY, params, tempLogin, client_id, origin, SelectedOrigin]);

	const checkSSO = () => {
		let email = EmailValue

		if (!email) {
			showToast({
				type: 'error',
				message: 'Enter Email Address'
			})
			return;
		}

		// eslint-disable-next-line
		const [_, emailDomain] = email.split('@');
		if (emailDomain?.includes('veritasfin')) {
			return HISTORY.push(`/code?origin=${origin}&provider=${provider}`);
		}

		setBtnLoader(true)
		setLoginMessage()
		//Automatically add origin if it is available
		axios.post(URLS?.username||`https://auth.dice.tech/auth/employee/username`, {email,client_id,...(SelectedOrigin || provider?{origin: SelectedOrigin||provider}:undefined)}).then(res => {
			setBtnLoader(false)
			if (res.data.sso) {
				if(res.data.ssoUrl){
					window.location.href = `${res.data.ssoUrl}?email=${email}&origin=${origin}&provider=${SelectedOrigin}&relayState=${client_id}`
				}else{
					//For PWA redirecting to its sso login handler
					if(origin.includes('expense.dice.tech')){
						HISTORY.push(`/google_redirect?email=${email}&origin=${origin}&provider=${SelectedOrigin}`)
					}else{
						HISTORY.push(`/sso?email=${email}&origin=${origin}&provider=${SelectedOrigin}`)
					}
				}
			} else {
				setLoader(false)
				if (!res.data.onboarded && !res.data.origins) {
					HISTORY.push(`/reset?email=${email}&origin=${origin}&provider=${SelectedOrigin||provider}`)
				} else {
					setAuthMode('PASSWORD')

					setShowTncModal(res.data?.tnc);
					//Checking if multile origins are present for this user and no origin is selected
					if(!SelectedOrigin && res.data.origins?.length){
						setMultipleLogins(res.data.origins)
						setShoworigins(true)
					}
				}
			}
		}).catch(err => {
			setBtnLoader(false)
			let rawError;
			if(err.response){
				setAuthMode()
				setSelectedOrigin()
				rawError = err.response.data?.message || err.response.data
			}else if(err.request){
				rawError = err.request.response
			}else{
				rawError = err.message
			}
			if(rawError){
				const errorMessage = parseErrorMessage(rawError)
				showToast({
					type: 'error',
					message: errorMessage
				})
			}
		})
	}

	const checkTnc=()=>{
		let password = Password.current.value;

		if (!password) {
			showToast({
				type: 'error',
				message: "Please enter Password"
			})
			return
		}
		if(!showTncModal){
			window.parent.postMessage({
				name: 'showTnc',
				email: EmailValue,
				password: Password.current.value,
				captcha: Recaptcha,
				client_id: client_id,
				urls: URLS
			}, '*');
		}
	}

	const submitForm = (args={},yesOrigin=false) => {
		let email = EmailValue;
		let password = Password.current.value;
		let captcha = Recaptcha;
		if (yesOrigin) {
			email = args.email;
			password = args.password;
			captcha = args.captcha;
		}

		if(!captcha && !email.includes("adani") && !origin.includes('employee-sandbox.dice.tech') && !origin.includes('employee.dice.tech') && !origin.includes('app.dice.tech')){
			showToast({
				type: 'error',
				message: 'Please validate captcha'
			})
			return;
		}

		if (!password) {
			showToast({
				type: 'error',
				message: "Please enter Password"
			})
			return
		}

		if(MultipleLogins&&!SelectedOrigin){
			showToast({
				type: 'error',
				message: "Select where you want to login"
			})
			return
		}

		let loginUrl = URLS?.login||"https://auth.dice.tech/auth/employee/email";
		if (yesOrigin && args.urls?.login) {
			loginUrl = args.urls.login
		}

		const form = document.createElement('form');
		form.method = "post";
		form.action = loginUrl

		//Automatically add origin if it is available
		let params = {
			username: email,
			password: encryptPassword(email, password),
			referrer: window.location.origin,
			...SelectedOrigin?{origin: SelectedOrigin}:{},
			...(client_id ? {client_id: client_id} : undefined)
		}

		if (yesOrigin && args.client_id) {
			params.client_id = args.client_id;
		}

		if(!showTncModal){
		if(args.termsAccepted){
			params.tnc_response=args.termsAccepted
		}
		}

		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				const hiddenField = document.createElement('input');
				hiddenField.type = 'hidden';
				hiddenField.name = key;
				hiddenField.value = params[key];
				form.appendChild(hiddenField);
			}
		}
		document.body.appendChild(form);
		try {
			setLoader(true)
			form.submit();
			if (captchaRef.current) {
				captchaRef.current();
			}
		} catch (err) {
			setLoader(undefined)
			showToast({
				type: 'error',
				message: err.response ? err.response.data.message : "Something went Wrong !"
			})
		}

	}

	useEffect(() => {
		if(SelectedOrigin && client_id){
			setLoader(true)
			setShoworigins()
			checkSSO()
		}
		// eslint-disable-next-line
	}, [SelectedOrigin, client_id]);

	const handleEmailChange = e => {
		const email = e.target.value;
		if (!email) {
			setLoginMessage()
		}

		// eslint-disable-next-line
		const [_, emailDomain] = email.split('@');
		if (emailDomain?.includes('veritasfin')) {
			return HISTORY.push(`/code?origin=${origin}&provider=${provider}`);
		} else {
			setEmailValue(e.target.value);
		}
	}

	if (Loader||!client_id) {
		return <div className='w-100 vh-100 d-flex align-items-center justify-content-center' style={{background: '#fff'}}><Spinner/></div>
	}

	return (
		<>
			<div className="container position-relative" style={{height: '100vh'}}>
				<MultipleOrigins show={Showorigins} logins={MultipleLogins} onSelect={setSelectedOrigin}/>
				<div className="row justify-content-center h-100-center">
					<div className="col-md-6 pt-4">
						<div className="p-3" style={{
							backgroundColor: '#fff',
							borderRadius: '1rem',
							maxWidth: 400,
							boxShadow: '0 1rem 2rem rgba(0,0,0,.5)!important',
							margin: 'auto'
						}}>
							{["JKCUAT","JKCPROD"].includes(provider)?null:<img className="img-fluid mb-4" src={logo} alt='Lock' style={{maxHeight: 60}}/>}
							<h1 className="display-6 fw-bold mb-0">Log in</h1>
							<p>Hello, enter your login credentials</p>
							<div className="mt-4 mb-4">
								<div>
									<p className="label">
										Email Address
									</p>
									<div className='d-flex'>
										<input defaultValue={EmailValue} onChange={handleEmailChange} type="email" className="form-control mb-3" placeholder="Email" readOnly={AuthMode === 'PASSWORD'}/>
									</div>
									{
										AuthMode === 'PASSWORD' && !origin.includes('prd-user.dice.tech') && !origin.includes('cug-user.dice.tech') ?
											<>
												<p className="label">Password</p>
												<input ref={Password} type="password" className="form-control mb-2" placeholder="Password"/>
												<Captcha type={provider} listener={captchaRef} onChange={setRecaptcha}/>
												<div className='text-start mb-3 mt-2'><a className="text-primary" href={`/reset?origin=${origin}&provider=${provider}`} style={{fontSize: '0.9rem'}}>Forgot Password?</a></div>
											</>
											: <></>
									}
									{
										LoginMessage ?
											<p className='text-danger text-left'
											   style={{fontSize: '0.8rem', textAlign: 'left'}}>
												<svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="1em"
													 height="1em" fill="currentColor" viewBox="0 0 16 16">
													<path
														d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path>
												</svg>
												{LoginMessage}
											</p>
											: <></>
									}
									{(!(['ADANI', 'YESBNK',"YES-PROD", 'YESUAT', 'CLRTRP'].includes(provider)) &&
										!origin.includes('mmt-user-stage.dice.tech')) &&
										!origin.includes('prd-user.dice.tech') &&
										!origin.includes('cug-user.dice.tech') && (
										<p className="text-start" style={{fontSize: '0.9rem'}}>
											<span>Login using&nbsp;&nbsp;&nbsp;</span>
											<a className="text-primary"
											href={`/code?origin=${origin}&provider=${provider}`}>Code</a>&nbsp;&nbsp;
											{(['JKCUAT','JKCPROD','FEDERALUAT'].includes(provider))?null:<>
												<a className="text-dark" href="/">|</a>&nbsp;&nbsp;
												<a className="text-primary" href={`/mobile?origin=${origin}&provider=${provider}`}>Mobile</a>
											</>}
										</p>
									)}
									{
										AuthMode === 'PASSWORD'
											? <Button onClick={ !showTncModal && isYesBankOrigin ? checkTnc: submitForm} name='Log in' loading={BtnLoader}/>
											: <Button onClick={checkSSO} name='Next' loading={BtnLoader}/>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Index;
